import React from "react";
import { Users, User as UserIcon, Building2, Car, Phone, IdCard } from "lucide-react";

const ACTIVE_EX = ["pending", "accepted", "completed"];

// Dati effettivi della prenotazione: scambio servizi attivo > fornitore (partner_id) > autista interno.
export function resolveExecutor(b, { ex, driver, vehicle, supplier }) {
  const veh = vehicle ? { name: [vehicle.brand, vehicle.model].filter(Boolean).join(" ") || null, plate: vehicle.plate || null } : null;
  if (ex && ex.to_operator_id && ACTIVE_EX.includes(ex.status)) {
    return {
      mode: "external", supplier: ex.to_operator_name || "Azienda partner", via: "Scambio servizi", pending: ex.status === "pending",
      extDriver: ex.to_driver_name || null,
      vehicle: ex.to_vehicle_name || ex.to_vehicle_plate ? { name: ex.to_vehicle_name || null, plate: ex.to_vehicle_plate || null } : null,
    };
  }
  if (b.partner_id) {
    const pv = b.partner_vehicle_name || b.partner_vehicle_plate ? { name: b.partner_vehicle_name || null, plate: b.partner_vehicle_plate || null } : veh;
    return {
      mode: "external", supplier: supplier?.name || b.partner_name || "Fornitore", via: "Fornitore",
      extDriver: b.partner_driver_name ? `${b.partner_driver_name}${b.partner_driver_phone ? ` · ${b.partner_driver_phone}` : ""}` : null,
      intDriver: !b.partner_driver_name && driver ? `${driver.first_name || ""} ${driver.last_name || ""}`.trim() : null, vehicle: pv,
    };
  }
  if (driver) return { mode: "internal", driver, vehicle: veh };
  return { mode: "none", vehicle: veh };
}

function Line({ icon: Icon, label, children, testid }) {
  return (
    <div className="flex items-center gap-3 py-1.5 text-sm" data-testid={testid}>
      <Icon size={15} className="text-slate-500 shrink-0" />
      <span className="text-slate-400 w-[104px] shrink-0">{label}</span>
      <span className="text-slate-100 font-medium min-w-0 break-words">{children}</span>
    </div>
  );
}

const Missing = ({ children }) => <span className="text-slate-500 italic font-normal">{children}</span>;

export function ExecutorSection({ info }) {
  const external = info.mode === "external";
  const badge = info.mode === "internal" ? "Autista interno" : external ? "Fornitore esterno" : null;
  return (
    <div data-testid="detail-executor">
      <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-amber-400/90 font-mono-num mb-2 font-bold">
        <Users size={11} /> Esecutore del servizio
      </div>
      <div className="rounded-xl border border-amber-500/50 bg-amber-500/[0.04] p-3.5 shadow-[0_0_0_1px_rgba(245,158,11,0.08)]">
        {info.mode === "none" ? (
          <div className="text-amber-200 font-semibold text-sm" data-testid="detail-executor-unassigned">Servizio non assegnato</div>
        ) : (
          <Line icon={UserIcon} label="Modalità" testid="detail-executor-mode">
            <span className="inline-flex items-center rounded-full border border-amber-500/60 bg-amber-500/15 text-amber-200 px-2.5 py-0.5 text-xs font-bold">{badge}</span>
            {external && info.pending && <span className="ml-2 text-[11px] text-amber-300/80">in attesa di accettazione</span>}
          </Line>
        )}
        {info.mode === "internal" && (
          <Line icon={IdCard} label="Autista" testid="detail-executor-driver">
            {info.driver.first_name} {info.driver.last_name}
            {info.driver.phone && <a href={`tel:${info.driver.phone}`} className="ml-2 inline-flex items-center gap-1 text-xs text-slate-400 hover:text-amber-400"><Phone size={11} />{info.driver.phone}</a>}
          </Line>
        )}
        {external && <>
          <Line icon={Building2} label="Fornitore" testid="detail-executor-supplier">{info.supplier}{info.via === "Scambio servizi" && <span className="ml-1.5 text-[10px] uppercase tracking-widest text-slate-500">· scambio</span>}</Line>
          {info.via === "Scambio servizi" || !info.intDriver ? (
            <Line icon={UserIcon} label="Autista esterno" testid="detail-executor-ext-driver">{info.extDriver || <Missing>Non registrato</Missing>}</Line>
          ) : (
            <Line icon={UserIcon} label="Autista" testid="detail-executor-ext-driver">{info.intDriver}</Line>
          )}
        </>}
        {(info.mode !== "none" || info.vehicle) && <>
          <Line icon={Car} label="Veicolo" testid="detail-executor-vehicle">{info.vehicle?.name || <Missing>Non indicato</Missing>}</Line>
          <Line icon={IdCard} label="Targa" testid="detail-executor-plate">{info.vehicle?.plate ? <span className="font-mono-num tracking-wider">{info.vehicle.plate}</span> : <Missing>Non indicata</Missing>}</Line>
        </>}
      </div>
    </div>
  );
}
